<template>
    <div class="search-query">
        <div class="code-selected" v-if="select && select.type == 'code'">
            <search-suggest-item :item="select" />
            <v-icon color="black" class="reset" @click="select = null">mdi-close-circle</v-icon>
        </div>
        <v-combobox
            v-if="!select || select.type != 'code'"
            v-model="select"
            :items="items"
            :search-input.sync="search"
            class="search-query-combo"
            dark
            label="Code NAF/APE, Numéro de brochure, IDCC, Mot clé..."
            flat
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="suggestion"
            :item-value="item => item.subtype + item.suggestion"
            solo-inverted
            return-object
            :no-filter="true"
            no-data-text=""
        >
            <template slot="item" slot-scope="data">
                <search-suggest-item :item="data.item" :search="search" />
            </template>
        </v-combobox>
    </div>
</template>

<script>
import SearchSuggestItem from "./SearchSuggestItem.vue";
import { Services } from "src/services/Services";

export default {
    props: ["value"],
    components: { SearchSuggestItem },
    data() {
        return {
            select: null,
            search: null,
            items: [],
        };
    },
    mounted() {
        this.select = this.value;
    },
    watch: {
        value() {
            this.select = this.value;
        },
        search(value) {
            if (!value) {
                this.items = [];
                return;
            }
            const suggestions = Services.search.getSuggestions(value);
            this.items = suggestions;
        },
        async select(value) {
            this.$emit("input", value);
        },
    },
};
</script>

<style lang="sass">
.search-query-combo
    &.v-text-field--solo
        border-radius: 0

    &.theme--dark.v-text-field--solo-inverted > .v-input__control > .v-input__slot
        background: white

    .theme--dark.v-label
        color: $color-text
        padding-left: 2px

    .theme--dark.v-icon
        color: $color-secondary

    &.theme--dark.v-input input
        caret-color: $color-text

    &.theme--dark.v-select .v-select__selection--comma,
    &.theme--dark.v-input input, .theme--dark.v-input textarea,
    .v-select__selections
        color: $color-text

.code-selected
    background: white
    height: 48px
    display: flex
    align-items: center
    padding: 0 10px
    box-sizing: border-box
    .reset
        margin-left: auto
</style>
